import { useState } from 'react';
import { useSession, Drawer, IconButton, Theme, useTranslation } from '@nextgen-web-framework/all';
import MePanelContainer from '../MePanelContainer/MePanelContainer';
import styles from './MePanelDrawer.module.scss';
import { MePanelDrawerProps } from './types/propsTypes';

const MePanelDrawer = ({ onMePanelClick, ...componentRestProps }: MePanelDrawerProps) => {
  const t = useTranslation();
  const { isAnonymous } = useSession();
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const onDrawerOpenHandler = () => {
    onMePanelClick?.(true);
    setIsDrawerOpen(true);
  };
  const onDrawerCloseHandler = () => {
    onMePanelClick?.(false);
    setIsDrawerOpen(false);
  };
  return (
    <div className={styles['me-panel-drawer-container']} data-testid={'me-panel-drawer-container-testId'}>
      <IconButton
        iconName="circle-user"
        onClick={onDrawerOpenHandler}
        theme={Theme.WHITE}
        data-testid="open-drawer-testId"
      />
      {isDrawerOpen && (
        <Drawer
          header={isAnonymous() ? <div>{t('web.mepanel.title')}</div> : <div></div>}
          closeIcon={true}
          closeOnBackdropClick={true}
          onClose={onDrawerCloseHandler}
        >
          <MePanelContainer onCloseHandler={onDrawerCloseHandler} {...componentRestProps} />
        </Drawer>
      )}
    </div>
  );
};

export default MePanelDrawer;
